import React from 'react';
import { BannerAlert } from '@trustpilot/businessapp-patternlibrary';
import { connect } from 'react-redux';
import { LinkText, useTranslations } from 'ilenia';
import { ShopDetails } from './models';
import { getMissingBillingPropsToText } from './utils/helpers';

interface BillingInformationAlertProps {
  shopDetails: ShopDetails;
  isMissingDetails: boolean;
  isPricingError: boolean;
  isCreatingOrderError: boolean;
}

type ErrorMessage = {
  id: number;
  appearance: 'success' | 'warning' | 'critical' | 'info' | undefined;
  header: string | undefined;
  message: any;
};

function BillingInformationAlert(props: BillingInformationAlertProps): JSX.Element | null {
  const [translations] = useTranslations();
  const { shopDetails, isPricingError, isMissingDetails, isCreatingOrderError } = props;
  if (!isMissingDetails && !isPricingError && !isCreatingOrderError) return null;

  const errorMessages: ErrorMessage[] = [];

  if (isPricingError || isCreatingOrderError) {
    const href = 'https://support.trustpilot.com/hc/en-us/requests/new?ticket_form_id=360000901820';
    errorMessages.push({
      id: 1,
      appearance: 'critical',
      header: translations['billingInformationAlert.criticalError.header'],
      message: () => <LinkText id="billingInformationAlert.criticalError.message" links={[{ href, target: '_blank' }]} />,
    });
  }

  if (isMissingDetails) {
    const href = `https://${shopDetails.shopDomain}/admin/settings/general`;
    const missingBillingPropsToText = getMissingBillingPropsToText(shopDetails);

    errorMessages.push({
      id: 2,
      appearance: 'warning',
      header: translations['billingInformationAlert.missingDetailsError.header'],
      message: () => (
        <LinkText
          id="billingInformationAlert.missingDetailsError.message"
          links={[{ href, target: '_blank' }]}
          interpolations={{ MISSING_FIELDS: missingBillingPropsToText }}
        />
      ),
    });
  }

  return (
    <div style={{ marginBottom: '1.5rem' }}>
      {errorMessages.map(({ id, appearance, message, header }) => (
        <div key={id} style={{ marginBottom: '0.5rem' }}>
          <BannerAlert appearance={appearance} header={header}>{message()}</BannerAlert>
        </div>
      ))}
    </div>
  );
}

const mapStateToProps = (state: any) => ({
  shopDetails: state.shop.details,
  isMissingDetails: state.shop.isMissingDetails,
  isCreatingOrderError: state.shop.isCreatingOrderError,
  isPricingError: state.pricing.isPricingError,
});

export default connect(mapStateToProps, {})(BillingInformationAlert);
